import { apiClient } from '@/lib/api/client'
import { Procedures, CreateProceduresData, UpdateProceduresData } from '@/types/procedures'


export const procedureService = {
  async getProcedures(): Promise<Procedures[]> {
    const response = await apiClient.get('/procedures')
    return response.data.data
  },


  async getProcedure(id: number | string): Promise<Procedures> {
    const response = await apiClient.get(`/procedures/${id}`)
    return response.data.data || response.data
  },


  async createProcedure(data: CreateProceduresData): Promise<{ message: string; data: Procedures }> {
    try {
      const response = await apiClient.post('/procedures', data)
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to create procedure')
    }
  },


  async updateProcedure(id: number | string, data: UpdateProceduresData): Promise<{ message: string; data: Procedures }> {
    try {
      const response = await apiClient.put(`/procedures/${id}`, data)
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update procedure')
    }
  },


  async deleteProcedure(id: number | string): Promise<{ message: string }> {
    try {
      const response = await apiClient.delete(`/procedures/${id}`)
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to delete procedure')
    }
  }
}